import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { downloadCSV, downloadTablePDF, downloadXLSX } from "@/lib/tableUtils";
import { Download } from "lucide-react";

export const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;

export function ConferenceStat({ label, value, hint, tone = "blue", testId }) {
  const tones = {
    blue: "text-brand-blue bg-brand-blue/10",
    green: "text-brand-green bg-brand-green/10",
    orange: "text-brand-orange bg-brand-orange/10",
    red: "text-destructive bg-destructive/10",
  };
  return (
    <Card className="p-4 hover-lift" data-testid={testId}>
      <div className={`w-2 h-2 rounded-full mb-3 ${tones[tone]?.split(" ")[0].replace("text-", "bg-")}`} />
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">{label}</div>
      <div className="text-2xl font-black mt-1">{value}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
    </Card>
  );
}

export function ConferenceStatus({ value }) {
  const v = String(value || "available");
  const cls = v === "verified" || v === "approved" || v === "active" || v === "Fulfilled"
    ? "bg-brand-green/15 text-brand-green border-brand-green/30"
    : v === "pending" || v === "pending_verification" || v === "allocated_to_district"
      ? "bg-brand-orange/15 text-brand-orange border-brand-orange/30"
      : v === "rejected" || v === "cancelled" || v === "damaged" || v === "lost"
        ? "bg-destructive/15 text-destructive border-destructive/30"
        : "bg-brand-blue/10 text-brand-blue border-brand-blue/30";
  return <Badge variant="outline" className={`${cls} capitalize`}>{v.replaceAll("_", " ")}</Badge>;
}

export function ExportButtons({ rows, title, filename, disabled = false, testId }) {
  const safeName = filename || title.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const run = (kind) => {
    if (!rows || rows.length < 2) return;
    if (kind === "csv") downloadCSV(rows, `${safeName}.csv`);
    if (kind === "xlsx") downloadXLSX(rows, `${safeName}.xlsx`, title.slice(0, 28));
    if (kind === "pdf") downloadTablePDF(rows, `${safeName}.pdf`, {
      title: `KELTA — ${title}`,
      brandColor: [13, 79, 181],
      accentColor: [246, 139, 31],
    });
  };
  return (
    <div className="flex flex-wrap gap-2">
      {['csv', 'xlsx', 'pdf'].map(kind => (
        <Button key={kind} variant="outline" size="sm" disabled={disabled || !rows || rows.length < 2} onClick={() => run(kind)} data-testid={`${testId}-${kind}`}>
          <Download className="w-3.5 h-3.5 mr-1.5" /> {kind === 'xlsx' ? 'Excel' : kind.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}

export function EmptyConferenceState({ title, text }) {
  return (
    <Card className="p-10 text-center">
      <div className="font-bold text-lg">{title}</div>
      <div className="text-sm text-muted-foreground mt-1">{text}</div>
    </Card>
  );
}
